export default "<div style='text-align: center;'>\n  <img style=\"width: 100px;\" [src]=\"url+'uploads/thumbnails/'+rowData.thumbnail\" alt=\"sadf\">\n</div>\n"